<template>
    <el-container style="height:inherit;width:100%;">
        <!-- 侧边栏 -->
        <el-aside id="elAside" v-bind:class="{ 'aside-scrollbar':true,activeStyle: isActive, 'text-act': isActives }" >
          <el-scrollbar style="height:100%;">
            <!-- 侧边栏的logo -->
            <div style="padding:32px 0px 43px 38px;" v-if="isCollapse == false">
              <!-- <img v-if="roleId != 5 && roleId != 6 && roleId != 8" src="../assets/img/u120.png" style="width:140px;"/> -->
              <img src="../assets/img/role-kehu.png" style="width:126px;height:103px;"/>
            </div>
            <div style="padding:15px 0px;color:#eee;font-size:16px;text-align:center;" v-else>
              TIBIOT
            </div>
            <!-- 菜单 -->
            <side-list :isCollapse="isCollapse"></side-list>
          </el-scrollbar>
        </el-aside>
        <el-container style="height:inherit;width:100%;background:#fff;">
            <el-header style="position:relative;border-bottom:1px solid #f1f1f1;">
              <!-- 控制菜单伸缩 -->
              <span @click="operationMenu" class="cursors" style="color:#666;position:absolute;top:15px;font-size:26px;">
                <i  style="color:#999;" class="el-icon-s-fold" v-if="isCollapse == false"></i>
                <i  style="color:#999;" class="el-icon-s-unfold" v-else></i>
              </span>
              <div style="position:absolute;top:22px;left:50px;">
                <!-- 面包屑 -->
                <el-breadcrumb  style="font-size:15px;padding-left:16px;">
                  <el-breadcrumb-item v-for="(item,index ) in crumbsArrss" :key="index" :to="{ path: item.url }">{{item.name}}</el-breadcrumb-item>
                </el-breadcrumb>
              </div>
              <!-- 用户的信息和退出 -->
              <el-dropdown style="float:right;padding-top:21px;cursor: pointer;"  @command="handleCommand">
                <span class="el-dropdown-link" style="font-weight:600;"> {{parallelUserName? parallelUserName :userName}}</span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item icon="el-icon-user" command="个人中心"> 个人中心</el-dropdown-item>
                  <el-dropdown-item icon="el-icon-switch-button" command="退出平台"> 退出平台</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <span class="su">|</span>
              <!-- 查看登录人群信息 -->
              <div class="signOut1" v-if="this.$store.state.roleId == 1" @click="handleOnLine()">
                <el-tooltip content="平台用户登录信息" placement="bottom">
                   <img src="../assets/img/top_dl.png" style="width:25px;">
                </el-tooltip>
              </div>
              <!-- API文档 -->
              <a href="https://api.tibiot.cn/docs/iot_api.html" target="_blank" class="signOut1 flexs" style="margin-top:14px;align-items: center;">
                <img src="../assets/img/top_api.png" style="width:32px;">
                <strong style="color:#8cbb1a;">文档</strong>
              </a>
               <!-- 文件下载中心 -->
              <div class="signOut1 flexs" style="margin-top:18px;align-items: center;margin-right:11px;"  @click="$router.push('/fileDownloadMag')">
                <img src="../assets/img/wenjianxz.png" style="width:24px;"/>
                <p class="color_f_1" >下载中心</p>
              </div>
              <!-- 前往CRM -->
              <!-- <div class="signOut1 flexs" @click="goCrm()" style="margin-top:16px;align-items: center;margin-right:25px;" v-if="roleId != 5 && roleId != 6 && roleId != 8" >
                <strong style="color:#e0620d;">To &nbsp;</strong> <img src="../assets/img/crm.png" style="width:28px;" />
              </div> -->
            </el-header>
            <!-- tabs视图 -->
            <tabsViews/>
            <el-main id="elMain" style="height:100%;">
              <el-scrollbar style="height:100%;" class="main-scorllbar">
                <!-- 主体内容 -->
                <div id="mainView">
                  <transition name="fade-transform" mode="out-in">
                    <keep-alive :include="cachedViews">
                      <router-view style="padding:12px;border-radius:5px;" ></router-view>
                    </keep-alive>
                  </transition>
                </div>
                <!-- 返回顶部 -->
                <el-backtop target="#elMain .el-scrollbar__wrap" :bottom="72" :right="22"></el-backtop>
              </el-scrollbar>
            </el-main>
            <el-footer v-if="roleId != 5 && roleId != 6 && roleId != 8" style="height:38px;line-height:38px;background:#efefef;text-align:right;">Copyright ©2021 齐犇科技集团有限公司</el-footer>
        </el-container>
        <el-dialog
            title="退出平台，你确定吗？"
            :visible.sync="SignOut.show"
            width="540px"
            :close-on-click-modal="false"
            >
              <div style="text-align:center;margin-top:14px;" >
                <div style="height:200px;" class="re">
                  <img class="ab" src="../assets/img/Out_pt.svg" alt="" style="width:300px;top:-66px;left:92px;">
                </div>
            </div>
            <span slot="footer" class="dialog-footer" >
                <el-button size="mini" round @click="cancel()">取 消</el-button>
                <el-button size="mini" round type="primary" @click="handleAdopt('SignOut')">我确定</el-button>
            </span>
        </el-dialog>
        <el-dialog
          title="用户登录信息"
          width='880px'
          :fullscreen='true'
          v-if="onLine.drawer"
          :visible.sync="onLine.drawer"
          :close-on-click-modal="false">
            <el-form  class="demo-form-inline Query_box" ref="formInline" :model="queryVal"  :inline="true" size="small" label-width="82px" >
              <el-form-item v-for="(item, index) in formInlines" :key="index" :label="item.label" :prop="item.prop">
                  <template v-if="item.type == 'input'">
                      <el-input v-model="queryVal[item.prop]" style="width:260px;" :placeholder="item.pleas" ></el-input>
                  </template>
              </el-form-item>
            </el-form>
            <div class="boderbottom" style="margin-bottom:20px;">
                <el-button type="primary" round plain size="mini" @click="flowQuery()" icon="el-icon-search">查询</el-button>
                <el-button type="primary" round plain size="mini" @click="flowRefresh()" icon="el-icon-refresh">重置</el-button>
                <el-button type="primary" round plain size="mini" @click="flowQuery()" icon="el-icon-refresh-right">刷新</el-button>
            </div>
            <el-table
                v-loading="tableDataObj.loading"
                element-loading-text="拼命加载中 ..."
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, .9)"
                :data="tableDataObj.tableData"
                style="width: 100%"
                border
                >
                    <el-table-column type="index" label="序号" width="50"></el-table-column>
                    <el-table-column v-for="index in checkList" :key="index"
                        :prop="tableDataObj.tableLabel[index].prop"
                        :label="tableDataObj.tableLabel[index].showName"
                        :width="tableDataObj.tableLabel[index].width"
                    >
                        <template slot-scope="scope">
                        <span>{{ scope.row[tableDataObj.tableLabel[index].prop] | formatters(tableDataObj.tableLabel[index].formatData)}}</span>
                        </template>
                    </el-table-column>
                     <el-table-column label="操作" width="70px" class="list-btn-pad">
                        <template slot-scope="scope">
                          <span @click="KickOut(scope.row)" class="them-color-w cursors"><i class="el-icon-circle-close"></i> 踢出</span>
                        </template>
                    </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div style="margin-top:12px;text-align:right;">
                <el-pagination
                    @size-change="handleSizeChange" :pager-count="5" background @current-change="handleCurrentChange" :current-page="queryVal.pageNum"
                    layout="total, prev, pager, next" :total="tableDataObj.totalSize">
                </el-pagination>
            </div>
            <span slot="footer" class="dialog-footer" >
                <el-button size="mini" round type="primary" @click="onLine.drawer = false ">知道了</el-button>
            </span>
        </el-dialog>
    </el-container>
</template>

<script>
import SideList from './SideList.vue'
import pagination from '../publicComponents/pagination.vue';
import queryBox from '../publicComponents/queryBox'
import { mapState, mapMutations,mapActions } from "vuex";
import tabsViews from './tabsViews'
import Vue from 'vue'
  export default {
    name: 'Main',
    data () {
      var checCompN = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('请输入公司名称'));
            }else if (value.length < 4) {
                return callback(new Error('长度在 4 到 50 个字符'));
            }else{
                this.$api.post(this.API.api + 'quotationCustomer/checkInsertCompName/'+value,{},res=>{
                    if(res.code == 200){
                        callback();
                    }else{
                        callback(res.message);
                    }
                })
            }
        };
      return {
        compName:"",
        originalVal:[],
        isCollapse:false,
        isActive:true,
        isActives:false,
        SignOut:{
          show:false,
        },
        onLine:{
          drawer:false
        },
        lists:[0,1,2,3,4],
        checkList:[0,1,2,3,4],
        formInline:[
            {label:"用户名",type:'input',isshow:"1",prop:'userName'},
            {label:"IP",type:'input',isshow:"1",prop:'loginIp'},
        ],
        //复制查询框的值
        queryVal:{
            userName:'',
            loginIp:"",
            pageNum:1,
            pageSize:10
        },
        tableDataObj: { //列表数据
            loading:false,
            tableData: [],
            totalSize:0,//总条数
            tableLabel:[
                {prop:"userName",showName:'用户名',width:'130',query:true},
                {prop:"loginIp",showName:'IP',query:true,width:'120'},
                {prop:"loginAgent",showName:'客户端',query:true},
                {prop:"loginTime",showName:'登录时间',query:true,width:'146'},
                {prop:"timeOut",showName:'剩余时长',query:true,width:'80'},
            ],
        },
        roleId:0,
        selectSupplierOpt:[],
      }
    },
    components:{
      SideList,pagination,queryBox,tabsViews
    },
    computed:{
       formInlines:function(){
            let a =[], data = this.formInline;
            for(let i =0; i< data.length;i++){
                if(data[i].isshow == '1'){
                    a.push(data[i]);
                }
            }
            return a;
        },
      ...mapState({  //比如'movies/hotMovies
        userName:state=>state.userName,
        parallelUserName:state=>state.parallelUserName,
      }),
      crumbsArrss(){
        let aa =[];
        if((this.$store.state.crumbsArr[1] == null) && (this.$store.state.crumbsArr.length != 1)){
          aa =[{name:'首页',url:'/home'}];
          return aa
        }else {
          aa=this.$store.state.crumbsArr;
          return aa;
        }
      },
      cachedViews(){
        return this.$store.state.cachedViews;
      }
    },
    created(){
      this.$router.push('/home');
      //获取用户信息
      this.$api.post(this.API.api + 'home/getLoginUserInfo',{},res=>{
        this.roleId = res.data.roleId;
        let param = {
          userName:res.data.userName,
          parallelUserName:res.data.parallelUserName,
          roleId:res.data.roleId,
          roleName:res.data.roleName,
          realName:res.data.realName,//真实姓名
          mobile:res.data.mobile, // 手机号
          email:res.data.email, // 邮箱
          customerType:res.data.customerType // 客户类型
        }
        this.saveInfo(param);

        //顺丰打印实例化（在Windows和特定角色才可以）
        if(this.$common.detectOS() === 'Windows' && (this.roleId == 11 || this.roleId == 15 || this.roleId == 16)){
          // 根据用户名获取顺丰配置信息
            this.$api.get(this.API.api + `express/getSFExpressConfig/${param.userName}`,{},res => {
              if(res.code == 200 || res.data.partnerID){
                // 引入SDK后初始化实例，仅执行一次
                const sdkCallback = result => {};
                const sdkParams = {
                    env: res.data.envFlag, // this.API.sdkEvn 生产：pro；沙箱：sbox。不传默认生产，转生产需要修改这里
                    partnerID: res.data.partnerID, // "QBKJJJR12N03"
                    callback: sdkCallback,
                    notips: false
                };
                const printSdk = new SCPPrint(sdkParams);
                
                //设置打印机
                printSdk.getPrinters(result => {
                  if (result.code === 1) {
                      if(result.printers.length){
                        console.log(result.printers)
                        let indexs = result.printers.find(ele=>ele.name == 'RP410-QB-SF-01').index;
                        printSdk.setPrinter(indexs);
                        Vue.prototype.printSdk = printSdk;
                      }else{
                        this.$message.error('找不到打印机！');
                      }
                  }
                });
              }else{
                this.$message.error('没有获取到 partnerID ！');
              }
            })
            
        }
      })
      
    },
    methods:{
      ...mapActions([  //比如'movies/getHotMovies
        'saveInfo',
        'saveMenuWidth'
      ]),
      //(确定))退出
      handleAdopt(){
        this.$api.post(this.API.api + 'home/logout',{},res=>{
          if(this.$common.getCookie('tibiot-company-card-web')){
            document.cookie='tibiot-company-card-web='+ this.$common.getCookie('tibiot-company-card-web') +';path=/;expires=Thu,01 Jan 1970 00:00:00 GMT';  //清除token
            window.localStorage.removeItem("vuex-along"); //清除vue-along
          }
          this.$router.push("./login");
        })
      },
      //取消
      cancel(){
        this.SignOut.show = false; //弹框关闭
        this.$message.info('已取消操作');
      },
      handleCommand(command){
        if(command == '退出平台'){
          this.SignOut.show = true;
        }else if(command == '个人中心'){
          this.$router.push('/personalInfo');
        }

      },
      //退出
      signOut(){

      },
      //前往crm
      goCrm(){
        this.$api.get(this.API.DL + 'sso/to/third/login?systemCode=OPEN_20220726173655001',{},res=>{
            if(res.code == 200){
              window.open(res.message + "?param=" + JSON.stringify(res.data), "_blank");  
            }else{
              this.$message.console.error('CRM平台跳转失败！！！');
            }
        })
      },
      //菜单收缩
      operationMenu(){
        let a = document.getElementById('elAside');
        this.isCollapse =!this.isCollapse;
        this.isActive = !this.isActive;
        this.isActives = !this.isActives;
        this.saveMenuWidth({menuWidth:(300 - a.offsetWidth)});
      },
      //打开平台现所有登录用户的信息
      handleOnLine(){
        this.onLine.drawer = true;
        this.getList();
      },
      //平台现所有登录用户的信息列表
      getList(){
        this.tableDataObj.loading = true;
        this.$api.post(this.API.api + 'home/getOnlineUser', this.queryVal,res=>{
            this.tableDataObj.tableData = res.data.records;
            this.tableDataObj.totalSize = res.data.totalCount;
            this.tableDataObj.loading = false;
        })
      },
      //查询
      flowQuery(){
        this.queryVal.pageSize = 10;
        this.queryVal.pageNum = 1;
        this.getList();
      },
      //刷新
      flowRefresh(){
        this.$refs.formInline.resetFields();//重置查询框
        this.flowQuery();
      },
       //分页
      handleSizeChange(size) {
          this.queryVal.pageSize = size;
          this.getList();
      },
      handleCurrentChange: function(pageNum){
          this.queryVal.pageNum = pageNum;
          this.getList();
      },
      handleClose(done) {
        done();
      },
      //踢出登录
      KickOut(val){
        this.sendRequest('确定踢出【'+val.userName+'】用户？','home/systemLoginOut',{userName:val.userName,loginToken:val.loginToken});
      },
      sendRequest(tips,url,obj){
        this.$confirms.confirmation('post',tips,'提示','warning',this.API.api + url,obj,res =>{
          this.getList();
        });
      },
        //取消
      cancels(formName){
          this[formName].show = false;
          this.$message.info({ message: '已取消操作!' });
      },
    },
    watch:{
        lists(val){
            let a = val.concat();
            this.$common.arrs(a);
            this.checkList = a;
        },
        'onLine.drawer'(val){
          if(!val){
            this.queryVal.pageNum = 1;
          }
        }
    }
  }
</script>
<style scoped>
.el-header {
  background-color:#fff;
  color: #666;
}
#main-header{
  height: 38px !important;
}
#main-header div{
  font-size:14px;
  font-weight: 500;
  height: 38px !important;
  line-height: 38px!important;
}
#mainView{
  padding:0px 15px;
  box-sizing:border-box;
}
.el-aside {
  background-color: #282B4C;
}
.el-main {
  padding:0 !important;
}
.signOut{
  float:right;
  margin-top:12px;
  font-size:20px;
  font-weight: bold;
  color:#5d5d5d;
  width:32px;
  height:32px;
  line-height:32px;
  border:1px solid #bdbdbd;
  background: #f1f1f1;
  border-radius:4px;
  text-align:center;
  cursor: pointer;
}
.signOut1{
    float:right;
    margin-top:18px;
    cursor: pointer;
    margin-right: 20px;
}
.signOut:hover{
  color:#077ef9;
  background: #ecf5ff;
  border:1px solid #077ef9;
}
.phone{
  display: inline-block;
  width:40px;
  height:40px;
  border-radius: 50%;
  overflow: hidden;
}
.phone img{
  width:100%;
}
.userTitle{
  float:right;
  padding-top:21px;
  color:#666;
  padding-right: 12px;
  font-weight: bold;
}
.su{
    float:right;
    padding-top:23px;
    color:#666;
    padding-right: 16px;
}
.top_api{
  margin-right: 20px;
  /* margin-top:19px; */
  cursor: pointer;
}
.activeStyle{
  height:inherit !important;
  width:240px !important;
  transition: width 0.2s;
}
.text-act{
  height:inherit !important;
  width:60px !important;
  transition: width 0.2s;
}
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all .3s;
}

.fade-transform-enter {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
.color_f_1{
    width:58px;
    font-weight:600;
    margin:0 auto;
    padding-left:6px;
    font-size:14px;
    color:#5358d9;
}
</style>
<style>
/* 禁止横向滚动条*/
.aside-scrollbar .el-scrollbar__wrap,.main-scorllbar .el-scrollbar__wrap{
  overflow-x: hidden !important;
}
/* .el-breadcrumb__item:last-child .el-breadcrumb__inner{
  color:#f1f1f1;
} */

</style>



// WEBPACK FOOTER //
// src/components/Main.vue